import { Box, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { FC, } from "react";
import BarChart from "../charts/barChart";
import useResponsive from "../../hooks/useResponsive";
import MedicEmploymentHistory from "./MedicEmploymentHistory";
import {
  MedicEmploymentProps,
} from "../../interface/medic";
import { ActiveEmployments } from "../BoxUI";

const MedicEmploymentInfo: FC<{
  medicEmployment: MedicEmploymentProps[];
  loading: boolean;
}> = ({ medicEmployment, loading }) => {
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xl");
  
  
  const headerSty = {
    fontFamily: "Lexend",
    fontWeight: 500,
    my: isMedium ? 2 : 3,
    color: theme.palette.neutral.light,
  };

  return (
    <>
      <Box
        sx={{
          margin: 3,
          padding: isMedium ? 3 : 4,
          borderRadius: "3px",
          minHeight: "100%",
          backgroundColor: theme.palette.common.white,
        }}
      >
         {/* <Typography sx={headerSty} variant="subtitle2">
        Employment Details
      </Typography>
      <DetailsUI
        type={"Full time"}
        title={"Doctor (Dr)"}
        department={"Ophthalmology"}
        startDate={"15th March, 2022"}
        endDate={"Nil"}
      /> */}

      <Typography sx={headerSty} variant="subtitle2">
        Active Employments
      </Typography>
      <ActiveEmployments
      job_title={medicEmployment[0]?.job_info?.job_title ?? "-"}
        hospital={medicEmployment[0]?.facility_info?.name ?? "-"}
        type={medicEmployment[0]?.job_info.employment_type ?? "-"}
        department={medicEmployment[0]?.job_info.department ?? "-"}
        start_date={medicEmployment[0]?.employment_details?.start_date}
        end_date={medicEmployment[0]?.employment_details?.end_date ?? "-"}
        status={medicEmployment[0]?.status}
      />
      {/* <ActiveEmployments
        hospital={"St. James Hospital Abuja"}
        type={"Full time"}
        department={"Ophthalmology"}
        start_date={"15th March, 2022"}
        end_date={"Nil"}
        status={"Serving"}
      />  */}
        <Stack>
          <Typography sx={headerSty} variant="subtitle2">
            Employment History
          </Typography>
          <MedicEmploymentHistory
            medicEmployment={medicEmployment}
            loading={loading}
          />
        </Stack>
        {/* <Stack direction={"row"} alignItems={"center"} sx={{ gap: 3, my: 4 }}>
          <Typography sx={{ ...headerSty, my: 0 }} variant="subtitle2">
            Rehire Eligibility Indicator
          </Typography>
          <span
            style={{
              background: theme.palette.success.light,
              padding: "8px 14px",
              borderRadius: "4px",
            }}
          >
            <p
              style={{
                color: theme.palette.success.main,
                fontSize: "12px",
                margin: 0,
                fontFamily: "Inter",
              }}
            >
              Positive
            </p>
          </span>
        </Stack>

        <Typography sx={{ ...headerSty, my: 4, mb: 2 }} variant="subtitle2">
          Historical Trend Analysis
        </Typography>

        <Box
          sx={{
            paddingY: 2,
            paddingX: isSmall ? 0 : 2,
            backgroundColor: "#FAFBFC",
            borderRadius: "6px",
            width: "100%",
            mt: 2,
            mb: 3,
          }}
        >
          <Typography
            variant="subtitle2"
            color={"neutral"}
            sx={{
              fontWeight: 700,
              fontFamily: "Inter",
              letterSpacing: "3%",
              mb: 1,
              paddingX: 2,
            }}
          >
            Employee count
          </Typography>
          <BarChart />
        </Box> */}
      </Box>
    </>
  );
};

export default MedicEmploymentInfo;
